import { Icon, IconProps } from ".";

export const Pistol = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M24.396 16.086H29.4731V14.3093H27.7802V12.5317H26.0881V10.7559H24.396V12.5317H22.7038V10.7559H21.0117V12.5317H7.47314V16.0861H9.16525V17.8637H10.8582V26.7482L15.9345 26.7473V21.4172H19.3197L19.3188 17.8637H24.3951L24.396 16.086ZM17.6275 19.6395H14.2423V17.8637H17.6275V19.6395Z" />
    </Icon>
  );
};
